import { SITE } from '@/app/constants';
import { FEATURE_IMAGES } from './media';

/** API 接入文档，国内外站点各一份。 */
export const API_ACCESS_DOC_URL =
  SITE === 'china' ? 'https://platform.vidu.cn/docs/vidu-s1' : 'https://platform.vidu.com/docs/vidu-s1';

export const FEATURE_KEYS = ['f2', 'f4', 'f1', 'f3'] as const;
export type FeatureKey = (typeof FEATURE_KEYS)[number];

export const FEATURE_ITEMS = FEATURE_KEYS.map((key) => ({
  key,
  image: FEATURE_IMAGES[key],
}));
